import { Operator } from '@empathy/survey/base';

export const OperatorText: Record<Operator, string> = {
  EQUAL: 'is answered with',
  EQUAL_ANY: 'is answered with any of the following answers',
  NOT_EQUAL: 'is not answered with',
  INCLUDES_ANY: 'includes any of the following answers',
  INCLUDES_ALL: 'includes all of the following answers',
  NOT_INCLUDES: 'does not include any of the following answers',
  NOT_INCLUDES_ALL: 'does not include all of the following answers',
  NOT_EMPTY: 'is not empty',
  CONTAINS: 'contains the following words',
  NOT_CONTAINS: 'does not contain the following words',
  GREATER_THAN: 'is greater than',
  GREATER_THAN_OR_EQUAL: 'is greater than or equal to',
  LESS_THAN: 'is less than',
  LESS_THAN_OR_EQUAL: 'is less than or equal to',
  NPS_SCORE: 'NPS Score',
  ONLY_IF: 'includes only the following answers',
  POSITION_BETWEEN: 'is ranked between',
  POSITION_NOT_BETWEEN: 'is not ranked between',
  POSITION_EQUAL: 'is ranked',
  POSITION_NOT_EQUAL: 'is not ranked',
  POSITION_INCLUDES_ANY: 'is ranked any of the following',
  POSITION_GREATER_THAN: 'is ranked greater than',
  POSITION_GREATER_THAN_OR_EQUAL: 'is ranked greater or equal to',
  POSITION_SMALLER_THAN: 'is ranked lower than',
  POSITION_SMALLER_THAN_OR_EQUAL: 'is ranked lower or equal to',
  NOT_SELECTED: 'is not ranked any of the following',
  SELECTED: 'is selected'
};
